import React, { useState, useEffect, useRef } from "react";
import Partner1 from "../../assets/img/partners/partner1.jpeg";
import Partner2 from "../../assets/img/partners/partner2.jpeg";
import Partner3 from "../../assets/img/partners/partner3.jpeg";
import Partner4 from "../../assets/img/partners/partner4.jpeg";
import Partner5 from "../../assets/img/partners/partner5.png";

export default function OurPartners() {
  const [imageError, setImageError] = useState({});
  const [isInView, setIsInView] = useState(false);
  const sectionRef = useRef(null);

  const handleImageError = (imageId) => {
    setImageError((prev) => ({ ...prev, [imageId]: true }));
  };

  const partnerImages = [
    {
      id: "partner1",
      src: Partner1,
      name: "SLNS LIFTS AND ELEVATORS PRIVATE LIMITED",
    },
    {
      id: "partner2",
      src: Partner2,
      name: "sneha tools and engineering works",
    },
    { id: "partner3", src: Partner3, name: "HINDUSTHAN ENGINEERING WORKS" },
    { id: "partner4", src: Partner4, name: "NOVEL TECH COMPANY" },
    { id: "partner5", src: Partner5, name: "adwaith brahma tech solutions" },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting);
      },
      { threshold: 0.5 }
    );

    const currentSectionRef = sectionRef.current;
    if (currentSectionRef) {
      observer.observe(currentSectionRef);
    }

    return () => {
      if (currentSectionRef) {
        observer.unobserve(currentSectionRef);
      }
    };
  }, []);

  const css = `
    @keyframes scroll {
      0% { transform: translateX(0); }
      100% { transform: translateX(-50%); }
    }

    .our-partners-section {
      background-color: #f9fafb;
      padding: 5rem 1rem;
      overflow: hidden;
      position: relative;
    }

    .our-partners-container {
      max-width: 1200px;
      margin: 0 auto;
      text-align: center;
    }

    .our-partners-title {
      font-size: 2.25rem;
      font-weight: 700;
      margin-bottom: 3rem;
      color: #7620ff;
    }

    .scroll-wrapper {
      overflow: hidden;
      position: relative;
      width: 100%;
    }

    .partner-logos-scroll {
      display: flex;
      gap: 3rem;
      width: max-content;
    }

    .scrolling {
      animation: scroll 40s linear infinite;
    }

    .our-partners-section:hover .scrolling {
      animation-play-state: paused;
    }

    .partner-logo-container {
      background-color: white;
      padding: 1.5rem;
      border-radius: 9999px;
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.06);
      display: flex;
      align-items: center;
      justify-content: center;
      width: 180px;
      height: 180px;
      flex-shrink: 0;
    }

    .partner-logo {
      max-height: 120px;
      max-width: 120px;
      object-fit: contain;
    }

    @media (max-width: 640px) {
      .partner-logo-container {
        width: 120px;
        height: 120px;
        padding: 1rem;
      }

      .partner-logo {
        max-height: 60px;
        max-width: 100px;
      }
    }
     .partner-name {
  margin-top: 1rem;
  font-size: 0.875rem;
  color: #333;
  text-align: center;
  max-width: 180px;
  word-wrap: break-word;
  text-transform: uppercase;
}


  `;

  return (
    <section className="our-partners-section" ref={sectionRef}>
      <style>{css}</style>
      <div className="our-partners-container">
        <h2 className="our-partners-title">Our Clients</h2>
        <div className="scroll-wrapper">
          <div
            className={`partner-logos-scroll ${isInView ? "scrolling" : ""}`}
          >
            {partnerImages.map(
              ({ id, src, name }, index) =>
                !imageError[id] && (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <div className="partner-logo-container">
                      <img
                        src={src}
                        alt={`Partner ${index + 1}`}
                        className="partner-logo"
                        onError={() => handleImageError(id)}
                      />
                    </div>
                    <span className="partner-name">{name}</span>
                  </div>
                )
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
